export const uploadFileIconMap = {
    xls: "upload-excel",
    xlsx: "upload-excel",
    doc: "upload-word",
    docx: "upload-word",
    ppt: "upload-ppt",
    pptx: "upload-ppt",
    pdf: "upload-pdf",
    pps: "upload-ppt",
    ppsx: "upload-ppt",
    csv: "upload-excel",
    txt: "upload-txt",
    jpg: "upload-photo",
    jpeg: "upload-photo",
    png: "upload-photo",
    zip: "upload-zip",
    rar: "upload-rar",
    '7z': "upload-7z",
    xlsm: "upload-excel",
    xlsb: "upload-excel",
    msg: "upload-msg",
    other: "upload-other",
};

export const getFileIcon = postfix => {
    if (!postfix.includes('.')) return uploadFileIconMap.other;
    const filePostfix = postfix.split('.');
    console.log(filePostfix)
    console.log(filePostfix[filePostfix.length - 1])
    console.log(filePostfix[filePostfix.length - 1].toLowerCase())
    if (filePostfix[filePostfix.length - 1].toLowerCase() in uploadFileIconMap) {
        return uploadFileIconMap[filePostfix[filePostfix.length - 1].toLowerCase()];
    }
    return uploadFileIconMap.other;
};